"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressErrorTypes = void 0;
var CheckoutConstants_1 = require("./CheckoutConstants");
var Utils = require("./UtilityFunctions");
var StateProvider_1 = require("../api/StateProvider");
var CommonUtilFuntions_1 = require("./CommonUtilFuntions");
var AddressService = /** @class */ (function () {
    function AddressService(response, addressType, isFromDLOption) {
        this.response = response;
        this.addressType = addressType;
        this.isFromDLOption = isFromDLOption;
        this.errorType = this.analyzeResponse();
    }
    AddressService.prototype.isAddressValid = function () {
        return !!(this.response.payload && this.response.payload.content &&
            this.isExactMatch(this.response.payload.content));
    };
    AddressService.prototype.isExactMatch = function (payloadContent) {
        var _a, _b;
        this.setWarnAddressError(payloadContent);
        var addrValidType = CommonUtilFuntions_1.getAddrValidationRec(payloadContent, this.addressType);
        return !!(addrValidType === AddressErrorTypes.ACCEPT || addrValidType === AddressErrorTypes.WARN ||
            (!addrValidType && (payloadContent.matchStatus === 'exactMatch' ||
                (payloadContent.matchStatus === 'USPS_MATCH' && ((_b = (_a = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.code) === '4S*'))));
    };
    AddressService.prototype.setWarnAddressError = function (payloadContent) {
        var _a, _b;
        // Adding BSSE flow case for WARN errors until for other flows it is confirmed
        if (Utils.IsBsseFlow() && CommonUtilFuntions_1.getAddrValidationRec(payloadContent, this.addressType) === AddressErrorTypes.WARN) {
            var errorCode = (payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.validationReasonCode) || ((_b = (_a = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.code);
            if (this.addressType === 'billing') {
                StateProvider_1.StateProvider.getStateManagerInstance().set('billingAddrValidationError', { billingError: true, errorCode: errorCode });
            }
            else if (this.addressType === 'shipping' || this.addressType === 'delivery') {
                StateProvider_1.StateProvider.getStateManagerInstance().set('shippingAddrValidationError', { shippingError: true, errorCode: errorCode });
            }
            else if (this.addressType === 'ppuAddress') {
                StateProvider_1.StateProvider.getStateManagerInstance().set('ppuAddrValidationError', { ppuError: true, errorCode: errorCode });
            }
        }
    };
    AddressService.prototype.getErrorType = function () {
        return this.errorType;
    };
    AddressService.prototype.analyzeResponse = function () {
        var errorType = AddressErrorTypes.UNKOWN;
        var response = this.response;
        if ((this.addressType === 'billing' || this.addressType === 'ppuAddress' ||
            (this.addressType === 'shipping' && Utils.getCurrentFlowType() === CheckoutConstants_1.FlowType.WIRELESS_PREPAID)) &&
            response.payload && response.payload.content
            && this.response.payload.content.showLibertyCto) {
            errorType = AddressErrorTypes.LIBERTY_CTO;
        }
        else if (response.payload && response.payload.content && this.isExactMatch(response.payload.content)
            && (this.addressType === 'shipping' || this.addressType === 'ppuAddress')
            && response.payload.content.matchedAddresses[0].addressType.toUpperCase() === 'P') {
            errorType = AddressErrorTypes.PO_BOX;
        }
        else if (response.payload && response.payload.content
            && (CommonUtilFuntions_1.getAddrValidationRec(response.payload.content, this.addressType) === AddressErrorTypes.LIST ||
                response.payload.content.matchStatus === 'multipleMatch')) {
            errorType = AddressErrorTypes.MULTIPLE_MATCH;
        }
        else if (this.addressType === 'delivery' &&
            !this.isFromDLOption &&
            (response.payload && response.payload.content &&
                this.isExactMatch(response.payload.content) &&
                (!response.payload.content.enjoyInfo || response.payload.content.enjoyInfo.errors ||
                    response.payload.content.enjoyInfo.errorCode))) {
            errorType = AddressErrorTypes.ENJOY_INFO;
        }
        else if (response.payload && response.payload.content
            && this.isExactMatch(response.payload.content)) {
            errorType = AddressErrorTypes.NO_ERROR;
        }
        else if (response.payload && response.payload.content) {
            errorType = AddressErrorTypes.RULE_ERROR;
        }
        else if (response.payload && response.payload.error) {
            errorType = AddressErrorTypes.PAYLOAD_ERROR;
        }
        return errorType;
    };
    return AddressService;
}());
exports.default = AddressService;
var AddressErrorTypes;
(function (AddressErrorTypes) {
    AddressErrorTypes["NO_MATCH"] = "NO_MATCH";
    AddressErrorTypes["PARTIAL_MATCH"] = "PARTIAL_MATCH";
    AddressErrorTypes["LIBERTY_CTO"] = "LIBERTY_CTO";
    AddressErrorTypes["PO_BOX"] = "PO_BOX";
    AddressErrorTypes["MULTIPLE_MATCH"] = "MULTIPLE_MATCH";
    AddressErrorTypes["ENJOY_INFO"] = "ENJOY_INFO";
    AddressErrorTypes["CONSIDERED_EXACT_MATCH"] = "CONSIDERED_EXACT_MATCH";
    AddressErrorTypes["NO_ERROR"] = "NO_ERROR";
    AddressErrorTypes["PAYLOAD_ERROR"] = "PAYLOAD_ERROR";
    AddressErrorTypes["RULE_ERROR"] = "RULE_ERROR";
    AddressErrorTypes["UNKOWN"] = "UNKOWN";
    AddressErrorTypes["ACCEPT"] = "ACCEPT";
    AddressErrorTypes["LIST"] = "LIST";
    AddressErrorTypes["WARN"] = "WARN";
    AddressErrorTypes["STOP"] = "STOP";
})(AddressErrorTypes = exports.AddressErrorTypes || (exports.AddressErrorTypes = {}));
//# sourceMappingURL=AddressService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/AddressService.js
// module id = 827
// module chunks = 8